import axios from 'axios'

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

const INIT_HEADERS = {
  'Accept-Language': localStorage.getItem('i18nextLng') || 'en'
}

export const axiosPrivet = axios.create({
  baseURL: API_BASE_URL,
  headers: INIT_HEADERS
})

export default axios.create({
  baseURL: API_BASE_URL,
  headers: INIT_HEADERS
})
